import { useState, useEffect } from "react";
import {
  Typography,
  Box,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseComment } from "./UseComment";
import { toMoney } from "../../util/Utils";
import GridContent from "./GridContent";
import ClearIcon from "@mui/icons-material/Clear";

export default function UserProfule(props) {
  const { GetUserProfile } = UseComment();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [profileRes, setProfileRes] = useState();

  useEffect(() => {
    if (props.openProfile && props.openProfile.mobile) {
      setProgress(true);
      GetUserProfile(props.openProfile.mobile, (callback) => {
        setProgress(false);
        setProfileRes(callback);
      });
    }
  }, [props.openProfile]);

  return (
    <Dialog
      PaperProps={{
        elevation: 1,
      }}
      maxWidth="lg"
      fullWidth
      open={props.openProfile.show}
      onClose={() =>
        props.setOpenProfile({ ...props.openProfile, show: false })
      }
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle color="secondary" id="alert-dialog-title">
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography color="secondary" variant="subtitle2">
            پروفایل کاربر
          </Typography>
          <IconButton
            onClick={() => {
              props.setOpenProfile({ ...props.openProfile, show: false });
            }}
          >
            <ClearIcon fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        {profileRes && (
          <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
            <Box gridColumn="span 3">
              <TextField
                fullWidth
                id="outlined-basic"
                label="شماره"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={profileRes ? profileRes.userID : ""}
                variant="filled"
              />
            </Box>
            <Box gridColumn="span 3">
              <TextField
                fullWidth
                id="outlined-basic"
                label="نام کاربر"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={profileRes ? profileRes.userName : ""}
                variant="filled"
              />
            </Box>
            <Box gridColumn="span 3">
              <TextField
                fullWidth
                id="outlined-basic"
                label="موبایل"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={profileRes ? profileRes.mobile : ""}
                variant="filled"
              />
            </Box>
            <Box gridColumn="span 3">
              <TextField
                fullWidth
                id="outlined-basic"
                label="تعداد سفارشات"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  profileRes.orderCount ? toMoney(profileRes.orderCount) : 0
                }
                variant="filled"
              />
            </Box>
            <Box gridColumn="span 3">
              <TextField
                fullWidth
                id="outlined-basic"
                label="تعداد کامنت ها"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  profileRes.commentCount ? toMoney(profileRes.commentCount) : 0
                }
                variant="filled"
              />
            </Box>
            <Box gridColumn="span 3">
              <TextField
                fullWidth
                id="outlined-basic"
                label="تعداد آدرس ها"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  profileRes.addressCount ? toMoney(profileRes.addressCount) : 0
                }
                variant="filled"
              />
            </Box>
            <Box gridColumn="span 3">
              <TextField
                fullWidth
                id="outlined-basic"
                label="تعداد پیشنهادات"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  profileRes.offerCount ? toMoney(profileRes.offerCount) : 0
                }
                variant="filled"
              />
            </Box>
            <Box gridColumn="span 3">
              <TextField
                fullWidth
                id="outlined-basic"
                label="تعداد مورد علاقه ها"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  profileRes.offerCount ? toMoney(profileRes.offerCount) : 0
                }
                variant="filled"
              />
            </Box>

            <Box gridColumn="span 12">
              <GridContent
                setMsScrollComment={props.setMsScrollComment}
                callBYID={props.callBYID}
                profileRes={profileRes}
                setOpenProfile={props.setOpenProfile}
                openProfile={props.openProfile}
              ></GridContent>
            </Box>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}
